import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import AlertModal from '../../ReactComponent/Modal/AlertModal';
import { P } from '../../../theme/typographySitecore';
import {
  HeaderContainer, SecondButton, OkayButton, ButtonGroup,
} from './css';

export const ForgotPasswordErrorModal = ({
  isOpen, onClose, parentFields, openSetForgotPasswordModal,
}) => {
  const header = () => (
    <HeaderContainer>
      <div>{parentFields.forgotPasswordErrorModalHeader.value}</div>
    </HeaderContainer>
  );

  const content = () => (
    <P field={parentFields.forgotPasswordErrorModalSummary} />
  );

  const actions = () => (
    <ButtonGroup>
      <SecondButton
        type="button"
        smallWidth
        onClick={openSetForgotPasswordModal}
      >
        {t('GoToForgotPassword')}
      </SecondButton>
      <OkayButton className="active" style={{ marginLeft: '5px' }} onClick={onClose}>
        {t('Okay')}
      </OkayButton>
    </ButtonGroup>
  );

  return (
    <AlertModal
      isOpen={isOpen}
      onClose={onClose}
      header={header}
      content={content}
      actions={actions}
    />
  );
};

ForgotPasswordErrorModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  parentFields: PropTypes.shape({
    forgotPasswordErrorModalHeader: PropTypes.object,
    forgotPasswordErrorModalSummary: PropTypes.object,
  }),
  openSetForgotPasswordModal: PropTypes.func,
};

export default ForgotPasswordErrorModal;
